import React, { useState } from 'react';
import { AnimatePresence, motion, useReducedMotion } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
import { Section, SectionHeading } from './Shared';
import { faqs } from '../data/faqs';
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const reduceMotion = useReducedMotion();
  return <Section className="max-w-3xl" data-id="element-44" data-mp="1ccncq8egfjxs">
      <SectionHeading character="問" className="mb-10" data-id="element-45" data-mp="2a2id6o3oeas1">
        LO QUE MÁS NOS PREGUNTAN
      </SectionHeading>
      <div className="divide-y divide-stone-200 overflow-hidden rounded-xl border border-stone-200 bg-white shadow-sm" data-id="element-46" data-mp="25472kb5k3w8r">
        {faqs.map((faq, index) => {
        const isOpen = index === openIndex;
        return <article key={faq.q} className="overflow-hidden" data-id="element-47" data-mp="1v46eyd0nmtyr" data-mpi={index}>
              <button type="button" onClick={() => setOpenIndex(isOpen ? null : index)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-6 px-5 py-5 text-left text-sm font-semibold text-stone-900 transition-colors duration-150 hover:bg-stone-50 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-[-4px] focus-visible:outline-emerald-700 md:px-6 md:text-base" data-id="element-48" data-mp="oonr1mw02jq2">
                <span data-id="element-49" data-mp="1aqc3flqs6zbp">{faq.q}</span>
                <ChevronDownIcon className={`h-5 w-5 shrink-0 text-stone-500 transition-transform duration-200 ${isOpen ? 'rotate-180' : ''}`} data-id="element-50" data-mp="1ap12rusmu7ot" />
              </button>
              <AnimatePresence initial={false} data-id="element-51" data-mp="11wyytmjcu99s">
                {isOpen && <motion.div initial={reduceMotion ? false : {
              opacity: 0,
              height: 0
            }} animate={{
              opacity: 1,
              height: 'auto'
            }} exit={reduceMotion ? undefined : {
              opacity: 0,
              height: 0
            }} transition={{
              duration: 0.2,
              ease: [0.23, 1, 0.32, 1]
            }} data-id="element-52" data-mp="11ve9qcft7ijb">
                    <p className="px-5 pb-5 text-sm leading-relaxed text-stone-600 md:px-6 md:text-base" data-id="element-53" data-mp="mzyh8buvnup1">
                      {faq.a}
                    </p>
                  </motion.div>}
              </AnimatePresence>
            </article>;
      })}
      </div>
    </Section>;
}